import { gql } from '@apollo/client/core';

export const organization = gql`query($id: String!) {
  getOrganization(orgId: $id) {
    id
    name
    slug
    email
    avatar
    about
    purpose
    background
    approved
    denied
    withdrawn
    bullhorns {
      id
      bullhorn
    }
    values {
      id
      value
    }
    channels {
      id
      channel
    }
    interests {
      id
      interest
    }
    organization_type
    profit_type
    nonprofit_type
    whyjoin
    whyjoin_other
    dob
    active
    is_creator
    stripe_onboarded
    stripeAccountId
    organizationTypes
    invite_code
    active,
    primaryAdmin {
      id
      email
      firstname
      lastname
      avatar
   }
   admins{
    id
    firstname
    lastname
    email
    avatar
  }
   createdAt
   isFeatured
  }
}`;

export const organizationPublicProfile = gql`query($id: String!) {
  organizationPublicProfile(id: $id) {
    id
    name
    email
    einNumber
    avatar
    about
    purpose
    background
    approved
    denied
    withdrawn
    bullhorns {
      id
      bullhorn
    }
    values {
      id
      value
    }
    channels {
      id
      channel
    }
    interests {
      id
      interest
    }
    organization_type
    profit_type
    nonprofit_type
    whyjoin
    whyjoin_other
    dob
    active
    is_creator
    stripe_onboarded
    stripeAccountId
    organizationTypes
    invite_code
    active,
    primaryAdmin {
      id
      email
      firstname
      lastname
      avatar
   }
   admins{
    id
    firstname
    lastname
    email
    avatar
  }
   createdAt
   isFeatured
  }
}`;

export const organizationPublicProfileBySlug = gql`query($slug: String!) {
  organizationPublicProfileBySlug(slug: $slug) {
    id
    name
    email
    einNumber
    avatar
    about
    purpose
    background
    approved
    denied
    withdrawn
    bullhorns {
      id
      bullhorn
    }
    values {
      id
      value
    }
    channels {
      id
      channel
    }
    interests {
      id
      interest
    }
    organization_type
    profit_type
    nonprofit_type
    whyjoin
    whyjoin_other
    dob
    active
    is_creator
    stripe_onboarded
    stripeAccountId
    organizationTypes
    invite_code
    active,
    primaryAdmin {
      id
      email
      firstname
      lastname
      avatar
   }
   admins{
    id
    firstname
    lastname
    email
    avatar
  }
   createdAt
   isFeatured
  }
}`;

export const updateOrganizationProfileByAdmin = gql` mutation ($input: AdminOrgProfileInput!){
   updateOrganizationProfileByAdmin(input: $input) {
      id
      name
      slug
      email
      avatar
      about
      purpose
      background
      bullhorns {
        id
        bullhorn
      }
      values {
        id
        value
      }
      channels {
        id
        channel
      }
      organization_type
      profit_type
      nonprofit_type
      whyjoin
      whyjoin_other
      dob
      organizationTypes
      invite_code
      active
      is_creator
      stripe_onboarded
      stripeAccountId
      primaryAdmin {
        id
        email
        firstname
        lastname
        avatar
      }
      createdAt
      isFeatured
   }
}`;

export const updateOrganizationProfile = gql` mutation ($orgId: String! $input: OrgProfileInput!){
   updateOrganizationProfile(orgId: $orgId input: $input) {
      id
      name
      slug
      email
      avatar
      about
      purpose
      background
      bullhorns {
        id
        bullhorn
      }
      values {
        id
        value
      }
      channels {
        id
        channel
      }
      organization_type
      profit_type
      nonprofit_type
      whyjoin
      whyjoin_other
      dob
      organizationTypes
      invite_code
      active
      is_creator
      stripe_onboarded
      stripeAccountId
      primaryAdmin {
        id
        email
        firstname
        lastname
        avatar
      }
      createdAt
   }
}`;

export const findAllOrganizations = gql`query {
   findAllOrganizations {
       id
       name
       onboarded
       active
       email
       avatar
       active
       onboarded
       approved
       denied
       withdrawn
       createdAt
   }
}`;

export const findPendingOrganizations = gql`query {
   findPendingOrganizations {
       id
       name
       onboarded
       approved
       denied
       active
       email
   }
}`;

export const getStripeAuthorizeUrl = gql`query getStripeAuthorizeUrl($orgId: String!) {
    getStripeAuthorizeUrl(orgId: $orgId)
}`;

export const completeStripeOnboarding = gql`mutation completeStripeOnboarding(
   $code: String! $state: String!) {
   completeStripeOnboarding(code: $code state: $state) {
      id
      name
      email
      avatar
      about
      purpose
      background
      bullhorns {
        id
        bullhorn
      }
      values {
        id
        value
      }
      channels {
        id
        channel
      }
      organization_type
      profit_type
      nonprofit_type
      whyjoin
      whyjoin_other
      dob
      organizationTypes
      invite_code
      active
      is_creator
      stripe_onboarded
      stripeAccountId
      primaryAdmin {
        id
        email
        firstname
        lastname
        avatar
      }
      createdAt
   }
}`;

export const createOrgFromInvite = gql`mutation($input: OrgInviteInput!){
  createOrgFromInvite(input: $input){
    id
    name
    dob
    email
    phone
    invite_code
  }
}`;

export const approveDenyOrganization = gql`mutation($id: String!, $approve: Boolean! ){
   approveDenyOrganization(id: $id, approve: $approve) {
     id
     approved
     active
     withdrawn
   }
 }`;

export const addAdminUserToOrgQuery = gql`mutation($orgId: String!, $userEmail: String!){
  addAdminUserToOrg(orgId: $orgId, userEmail: $userEmail)
}`;

export const removeAdminUserFromOrgQuery = gql`mutation($orgId: String!, $userId: String!){
  removeAdminUserFromOrg(orgId: $orgId, userId: $userId)
}`;

export const removeStripeAccount = gql`mutation($orgId: String!){
  removeStripeAccount(orgId: $orgId)
}`;


export const findSyncedBenevityCauses = gql`query ($benevityCausesPaginationInput: BenevityCausesPaginationInput!) {
  findSyncedBenevityCauses(benevityCausesPaginationInput: $benevityCausesPaginationInput) {
    totalCount
    benevityCauses {
      id
      causeId
      causeName
      claimStatus
      email
      claimer {
        id
        firstname
        lastname
      }
    }
  }
}`;

export const getBenevityCauseSyncById = gql`query ($claimRequestId: String!) {
  getBenevityCauseSyncById(id: $claimRequestId) {
    id
    causeId
    causeName
    logo
    eMail
    description
    claimStatus
    userInfo {
      id
      email
    }
    ein
  }
}`;

export const updateBulkClaimStatus = gql`
mutation($input: [updateStatusInput!]!) {
  updateBulkClaimStatus(input: $input)
}`;

export const updateClaimStatus = gql`
mutation($input: updateStatusInput!) {
  updateBenevityCauseStatus(updateStatus: $input)
}`;

export const findOrganizations = gql`
  query FindOrganizations {
    findOrganizations {
      id
      name
      phone
      email
      avatar
      background
      approved
      organization_type
      onboarded
      invite_stage
    }
  }
`;

export const findOrganizationsV2 = gql`query ($baseInput: BaseInput!) {
  findOrganizationsV2(baseInput: $baseInput) {
      id
      name
      onboarded
      active
      email
      avatar
      active
      onboarded
      approved
      denied
      withdrawn
      createdAt
  }
}`;

// Sticker portal's Total Revenue card: with a one-day range of today, `cumulative` is all-time.
export const findOrganizationTotalRevenue = gql`
query ($organizationId: UUID!, $startDate: DateTime!, $endDate: DateTime!) {
  findOrganizationMetrics(organizationId: $organizationId, startDate: $startDate, endDate: $endDate) {
    lastGrossRevenue { cumulative }
  }
}`;

export const findOrganizationMetrics = (organizationId: string, startDate: string, endDate: string) => gql`query FindOrganizationMetrics {
    findOrganizationMetrics(organizationId: "${organizationId}", startDate: "${startDate}", endDate: "${endDate}") {
        hasData
        startDate
        endDate
        donationsReceived {
            date
            new
            cumulative
        }
        lastDonationReceived {
            date
            new
            cumulative
        }
        grossRevenue {
            date
            new
            cumulative
        }
        lastGrossRevenue {
            date
            new
            cumulative
        }
        followersCount {
            date
            new
            cumulative
        }
        lastFollowersCount {
            date
            new
            cumulative
        }
        alliesCount {
            date
            new
            cumulative
        }
        lastAlliesCount {
            date
            new
            cumulative
        }
        affiliatesCount {
            date
            new
            cumulative
        }
        lastAffiliatesCount {
            date
            new
            cumulative
        }
        stickersCount {
            date
            new
            cumulative
        }
        lastStickersCount {
            date
            new
            cumulative
        }
        campaignsCount {
            date
            new
            cumulative
        }
        lastCampaignsCount {
            date
            new
            cumulative
        }
        ticketsCount {
            date
            new
            cumulative
        }
        lastTicketsCount {
            date
            new
            cumulative
        }
        sweepstakesCount {
            date
            new
            cumulative
        }
        salesAmountSumFromSocialShops {
            date
            new
            cumulative
        }
        lastSalesCountSumFromSocialShops {
            date
            new
            cumulative
        }
        salesCountSumFromSocialShops {
            date
            new
            cumulative
        }
        lastProductsAddedToSocialShopsCount {
            date
            new
            cumulative
        }
        productsAddedToSocialShopsCount {
            date
            new
            cumulative
        }
        lastSalesAmountSum {
            date
            new
            cumulative
        }
        salesAmountSum {
            date
            new
            cumulative
        }
        lastSweepstakesCount {
            date
            new
            cumulative
        }
        moneyLeftInTheAccount {
            amountInWallet
            hasWallet
        }
        recentSupporters {
            transactionId
            transactionDate
            totalAmount
            stickerId
            stickerName
            purchaserEntity
            purchaserEntityId
            purchaserName
        }
        mostSupportedStickers {
            stickerId
            stickerName
            salesCount
            salesAmount
        }
        referralConversions {
            referralEntity
            referralId
            referralName
            salesCount
            salesAmount
        }
        lastSalesAmountSumFromSocialShops {
            date
            new
            cumulative
        }
        ownSocialShopSales {
            salesCount
            salesAmount
            allTimeSalesCount
            allTimeSalesAmount
            campaigns {
                stickerId
                stickerName
                campaignType
                creatorEntity
                creatorEntityId
                creatorName
                listedAt
                salesCount
                salesAmount
                allTimeSalesCount
                allTimeSalesAmount
            }
        }
    }
}`;

export const findSupportedCauses = gql`
query($orgId: String, $groupId: String, $skip: Int, $take: Int) {
  findSupportedCauses(orgId: $orgId, groupId: $groupId, skip: $skip, take: $take) {
    id
    entity
    entityId
    causeId
    causeName
    causeLogo
    causeDescription
    sortOrder
    createdAt
    updatedAt
  }
}`;

export const mutateSupportedCause = gql`
mutation($input: SupportedCauseInput!, $orgId: String, $groupId: String) {
  mutateSupportedCause(input: $input, orgId: $orgId, groupId: $groupId) {
    id
    causeId
    causeName
    causeLogo
    causeDescription
    sortOrder
  }
}`;

export const mutateRemoveSupportedCause = gql`
mutation($causeId: String!, $orgId: String, $groupId: String) {
  mutateRemoveSupportedCause(causeId: $causeId, orgId: $orgId, groupId: $groupId)
}`;
